(() => {
  if (customElements.get('rp-product-details-layout')) return;
  customElements.define('rp-product-details-layout', class extends HTMLElement {
    connectedCallback() {
      if (this.media) return;
      this.root = this.closest('product-info');
      this.content = this.nextElementSibling;
      if (!this.root || !this.content?.matches('.rp-product-below-media')) return;
      this.media = window.matchMedia('(max-width: 749px)');
      this.reposition = () => {
        const help = this.root.querySelector('.product__info-container .rp-design-help');
        const arrival = this.root.querySelector('.product__info-container .shipping-estimate');
        const mobileAnchor = arrival || help;
        const anchor = this.media.matches && mobileAnchor ? mobileAnchor : this;
        if (anchor.nextElementSibling !== this.content) anchor.after(this.content);
      };
      this.media.addEventListener('change', this.reposition);
      this.reposition();
    }
    disconnectedCallback() {
      this.media?.removeEventListener('change', this.reposition);
      this.media = null;
    }
  });
})();
